var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultProfileFemale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99.0004,
    rx: 49.5,
    fill: "#EBEBEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99.0004,
    rx: 49.5,
    stroke: "#D7D7D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9987 56.4583C38.4335 56.4583 34.3005 49.974 33.3107 47.9875C33.1606 47.6865 33.1744 47.326 33.3463 47.0388C34.2827 45.4702 36.7977 41.0417 37.1829 39.3978C39.0756 31.3607 43.7439 26.75 49.9987 26.75C56.2515 26.75 60.9219 31.3588 62.8145 39.3958C63.1997 41.0417 65.7147 45.4682 66.6492 47.0368C66.8235 47.326 66.8368 47.6845 66.6867 47.9855C65.6945 49.974 61.5639 56.4583 49.9987 56.4583Z",
    fill: "#C7C7C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9859 60.6528L55.167 57.9753C53.609 58.2578 51.9042 58.4298 50.0013 58.4298C47.6178 58.4298 45.5158 58.1748 43.6653 57.75L42.5714 60.5678C36.5907 60.8998 28.043 65.3874 28.043 71.274V72.262C28.043 72.8054 28.4901 73.25 29.0411 73.25H70.9615C71.5105 73.25 71.9596 72.8054 71.9596 72.262V71.274C71.9596 65.2762 61.9826 60.9927 55.9859 60.6528Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileFemale);
export default __webpack_public_path__ + "static/media/Default Profile - Female.4bdd70172f8eaa607d751bd282a33008.svg";
export { ForwardRef as ReactComponent };